export default __webpack_public_path__ + "static/Susanne_Sklar-2e9b0768325150dc41b57ca8b82ddd0c.jpg";